import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Media } from "../../types"
import { initialValuesMedia, validationSchemaMedia } from "./MediaCommon"
import MediaForm from "./MediaForm"
import { useDeleteMedia, useMedia, useUpdateMedia } from "../../hooks/media"

export default function MediaUpdate() {
  const updateMedia = useUpdateMedia()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: media } = useMedia(Number(id))

  const deleteMedia = useDeleteMedia()

  const [modalStateDeleteMedia, modalActionsDeleteMedia] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesMedia(media), [media])
  const validationSchema = useMemo(() => validationSchemaMedia(), [])

  useBreadcrumbs([{ label: "Immagini", href: "/media/media" }, { label: "Dettaglio Immagine" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>Dettaglio Immagine</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteMedia.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              if (typeof values.media_file === "string") {
                delete values.media_file
              }
              return updateMedia.mutateAsync(values as Media).then(() => {
                navigate(`/media/media`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <MediaForm />
                </Container>
                <BottomFormFixed url="/media/media" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteMedia.isOpen}
        onClose={modalActionsDeleteMedia.close}
        onDelete={() => {
          return deleteMedia.mutateAsync(media?.id).then(() => {
            navigate(`/media/media`)
          })
        }}
        message="Sei sicuro di voler eliminare il media?"
        title="Elimina Media"
      />
    </Layout>
  )
}
